import { render, staticRenderFns } from "./capitalRecord.vue?vue&type=template&id=6d488d7c&scoped=true&"
import script from "./capitalRecord.vue?vue&type=script&lang=js&"
export * from "./capitalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d488d7c",
  null
  
)

export default component.exports